import styled from 'styled-components';
import colors from '../../../theme/colors';

const IconContainer = styled.span`
    display: flex;
    align-items: center;
`;

const LogoEventials = () => {
    return (
        <IconContainer>
            <svg width="24" height="24" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 6.58576C0 3.36865 2.50834 0.736281 5.65774 0.648369L25.6903 0.0891113L45.7228 0.648369C48.8722 0.736281 51.3806 3.36865 51.3806 6.58576V37.1498C51.3806 40.3669 48.8722 42.9992 45.7228 43.0872L30.1222 43.5227C30.3641 45.2024 31.2268 46.7325 32.5412 47.79C32.7958 47.9949 32.9611 48.2999 32.9611 48.6309V49.0911C32.9611 49.6378 32.527 50.081 31.9917 50.081H19.3889C18.8535 50.081 18.4194 49.6378 18.4194 49.0911V48.6309C18.4194 48.2999 18.5848 47.9949 18.8393 47.79C20.1537 46.7325 21.0164 45.2024 21.2583 43.5227L5.65774 43.0872C2.50834 42.9992 0 40.3669 0 37.1498V6.58576ZM15.1195 10.8963L38.2019 21.2083C38.9764 21.5543 38.9764 22.6762 38.2019 23.0222L15.1195 33.3342C14.6428 33.5472 14.2172 32.948 14.5634 32.5514L19.0735 27.3851C21.6952 24.3819 21.6952 19.8486 19.0735 16.8454L14.5634 11.6791C14.2172 11.2825 14.6428 10.6833 15.1195 10.8963Z" fill={colors.primary}/>
            </svg>
        </IconContainer>
    )
}

export default LogoEventials;